
















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { Pagination, sortOrdering } from '../models/pagination';
import { ListParams } from '../models/list-params';
import { Product } from '../models/product';
import { errorMessage } from '../store/types';

@Component({
  name: 'Products',
})
export default class Products extends Vue {
  @Action('org/products/fetchProducts') fetchProducts!: (
    queryParams: ListParams
  ) => Promise<number>;
  @Getter('org/products/getProducts') products!: () => Product[];
  @Getter('org/products/getSearch') getSearch!: string;
  @Mutation('org/products/setSearch') setSearch!: (search: string) => void;

  loading = true;
  pagination: Pagination = {
    page: 1,
    itemsPerPage: 20,
    sortBy: ['invoice.invoiceNumber'],
    sortDesc: [true],
  };
  totalProducts = 1;
  errorMessage = '';

  tableHeaders = [
    { text: 'T3', value: 't3', sortable: false },
    { text: 'Invoice', value: 'invoice.invoiceNumber' },
    { text: 'NDC', value: 'ndc' },
    { text: 'Product', value: 'product' },
    { text: 'Size', value: 'size' },
    { text: 'Qty', value: 'quantity', align: 'right' },
    { text: 'Lot #', value: 'lotNumber' },
    { text: 'Exp. Date', value: 'expirationDate', align: 'right' },
  ];

  @Watch('pagination')
  onPropertyChanged(pagination: Pagination) {
    this.pagination.page = pagination.page;
    this.getData({
      page: this.pagination.page,
      limit: this.pagination.itemsPerPage,
      sort: sortOrdering(this.pagination),
      q: this.getSearch,
    });
  }

  searchHandler(search: string): void {
    this.setSearch(search);
    this.getData({
      page: this.pagination.page,
      limit: this.pagination.itemsPerPage,
      sort: sortOrdering(this.pagination),
      q: this.getSearch,
    });
  }

  getData(queryParams: ListParams): void {
    this.loading = true;

    this.fetchProducts(queryParams)
      .then(totalItemsFound => {
        this.loading = false;
        this.totalProducts = totalItemsFound;
      })
      .catch((error: errorMessage) => {
        this.loading = false;
        this.errorMessage = error.message;
      });
  }
}
